import {
  put,
  fork,
  call,
  takeEvery,
  all,
  select,
  take,
} from 'redux-saga/effects';
import app from '../../app';
import {
  loadMineCompletion,
  loadHomeMineCompletion,
  loadShareCodeInfo,
  loadMemberInfo,
} from '../../actions';
import mallSaga from './mall';

export function* watchLoadMine() {
  yield takeEvery('LOAD_MINE', function*() {
    const options = {
      url: '/api/performance/own/index',
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadMineCompletion(result.data, result.error));
  });
}

function* watchLoadHomeMine() {
  yield takeEvery('LOAD_HOME_MINE', function*({ reload }) {
    const { didLoadAt } = yield select(state => state.home.mine.loadInfo);
    if (!reload && new Date().getTime() - didLoadAt < 3 * 60 * 1000) {
      yield put(loadHomeMineCompletion(new Error('请求太频繁')));
      return;
    }
    yield put(loadShareCodeInfo());
    yield put(loadMemberInfo());

    yield all([
      take('LOAD_MINE_COMPLETION'),
      take('LOAD_SHARE_CODE_INFO_COMPLETION'),
      take('LOAD_MEMBER_INFO_COMPLETION'),
    ]);
    yield put(
      loadHomeMineCompletion(undefined, undefined, new Date().getTime())
    );
  });
}

export default function* homeSaga() {
  yield all([fork(mallSaga), fork(watchLoadMine), fork(watchLoadHomeMine)]);
}
